import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import "./style.scss";

const InputUI = ({
    addClass = "",
    dataId = [],
    label = "",
    required = false,
    placeholder = "",
    value,
    onChange = () => {},
    onFocus = () => {},
    disabled = false,
    keyfilter = "",
    maxLength = false,
    className = "",
    error = false,
    type = "text",
    icon = "",
    iconPosition = "left",
}) => {
    return (
        <div className={"detail__item input-ui " + addClass + className}>
            {label.length ? (
                <label className={dataId.join("-")} data-pr-tooltip={label}>
                    {label}
                    {required ? "*" : ""}
                </label>
            ) : null}

            <IconField iconPosition={iconPosition}>
                <InputIcon className={icon} />
                <InputText className={icon ? "input-ui__with-icon" : ""} placeholder={placeholder} value={value || ""} onChange={onChange} disabled={disabled} keyfilter={keyfilter} invalid={error} type={type} onFocus={onFocus} />
            </IconField>

            {maxLength ? (
                <span className={`input-ui__max-length ${value.length > maxLength ? "input-ui__max-length_red" : ""}`}>
                    {value.length} / <span className="input-ui__max-length_gray">{maxLength}</span>
                </span>
            ) : null}
        </div>
    );
};

export default InputUI;
